"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CommandManager {
    constructor() {
        this.pendingCommands = [];
        this.completedCommands = [];
    }
    addToQueue(command) {
        // pendingCommands.append(command)
        return command.execute();
        // pendingCommands.remove(at: pendingCommands.count)
        // Run if possible
        // self.performNextCommands()
    }
    performNextCommands() {
        // Always check that receiver exists in universe.
        //     else, load it up, then run execute
        // Check whether we are online
        // If all good, run command.execute
        // if let command = pendingCommands.first() {
        //     command.execute()
        //     pendingCommands.removeAt(0)
        //     completedCommands.append(command)
        // }
    }
}
CommandManager.shared = new CommandManager();
exports.default = CommandManager;
//# sourceMappingURL=OMCommandManager.js.map